module.exports = __webpack_public_path__ + "assets/de87cdd2aacf91ed71bbd1beb9991298.mp3";